<template>
  <div>
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'System'
}
</script>

<style>

</style>
